/* eslint no-param-reassign: 0 */

export const confirmedAccomodations = ($) => {
  const accomodations = $.cart.accomodations;
  return accomodations.filter((accomodation) => {
    const confirmed = accomodation.confirmed;
    return confirmed;
  });
};

export const loggedIn = $ => !!$.user.token;

export const favoriteAccommodations = $ => $.favorites;

export const isAwaitingFilter = $ => $.isAwaitingFilter;

export const accomodationsFilterEndDate = $ => $.accomodationsFilter.date.endDate;

export const accomodationsFilter = $ => JSON.stringify($.accomodationsFilter);

export default 'bar';



// WEBPACK FOOTER //
// ./src/store-methods/getters/accomodation.js